import * as React from 'react';
type Props = {
  className?: string;
};
export function Box({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-box"
      className={className}
    >
      <path
        d="M16 2C16.2652 2 16.5196 2.10536 16.7071 2.29289L21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V8C2 7.73478 2.10536 7.48043 2.29289 7.29289L7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16ZM20 9H4V20H20V9ZM15.585 4H8.414L5.414 7H18.585L15.585 4ZM12 17C14.6888 17 16.8818 14.8777 16.9954 12.2169L17 12H15C15 13.6569 13.6569 15 12 15C10.4023 15 9.09634 13.7511 9.00509 12.1763L9 12H7C7 14.7614 9.23858 17 12 17Z"
        fill="currentColor"
      />
    </svg>
  );
}
